export default "__VITE_ASSET__iMPzFqcL__"